import { useState, useEffect, useRef, useCallback } from 'react';
import './style.scss'
import { useSelector } from 'react-redux';
import { Spin, notification } from 'antd';
import { extendUsetts } from "../../utils";
import useBluetooth from '../../hooks/useBluetooth';

const initParameter = {
    voice: '磁性男声',
    spd: '5',
    pit: '5',
    vol: '5',
    per: '5003'
}
const Speechcx2 = () => {
    const audioURL = useRef('');
    const lastTriggerTime = useRef(0);
    const audioPoint = useRef(null);
    const curProgress = useRef(null);
    const parameterRef = useRef(initParameter)
    const [parameter, setParameter] = useState(initParameter);
    const [hasAudio, setHasAudio] = useState(false);
    const audio = useRef(null)
    const playTimer = useRef(null)
    const [text, setText] = useState('');
    const [uid, setUid] = useState('');
    const [loading, setLoading] = useState(false);
    const [curTime, setCurTime] = useState(0);
    const [audioPlaying, setAudioPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const audioMap = useRef(new Map())

    const bluetooth = useSelector(state => state.speaker.bluetooth);
    const { sendMessage, setupNotifications, stopNotifications } = useBluetooth();

    useEffect(() => {
        parameterRef.current = parameter
    }, [parameter])

    useEffect(() => {
        if (text) {
            console.log('')
            console.log('合成完成-----：', text)
            const now = Date.now();
            if (now - lastTriggerTime.current < 500) {
                notification.error({
                    message: '错误',
                    description: '朗读积木每秒钟最多被触发 2 次',
                });
                return;
            }
            
            lastTriggerTime.current = now;
            setHasAudio(true)
            setLoading(true);
            let newSpe = new URLSearchParams(parameterRef.current);
            let _audioURL = `https://ai.eliteu.cn/wxapi/tts?text=${text}&${newSpe}`;
            audio.current = new Audio(_audioURL);
            const loadedmetadata = () => {
                cleatPlayTimer()
                sendMessage({ [uid]: { content_time: audio.current.duration } })
                const _duration = Math.round(audio.current.duration)
                console.log('');
                console.log('音频时长(秒):', _duration);
                setLoading(false);
                setDuration(_duration)
                playAudio(_duration)
                if (_audioURL !== audioURL.current) {
                    extendUsetts({
                        extension_id: 'speechcx2',
                        platform: 'lab',
                        ...parameterRef.current
                    })
                    audioURL.current = _audioURL;
                }
                audio.current.removeEventListener('loadedmetadata', loadedmetadata)
            }
            // 监听音频加载完成事件以获取时长
            audio.current.addEventListener('loadedmetadata', loadedmetadata);
            // 添加音频播放完成事件，若已播放完成，则添加一个已播放的标志
            audio.current.addEventListener('ended', () => {
                audioMap.current.set(uid, 'ended')
            })
            audioMap.current.set(uid, audio.current)
        } else {
            audio.current = null
        }
    }, [text, uid])
    
    const cleatPlayTimer = () => {
        clearInterval(playTimer.current);
        playTimer.current = null;
    };
    
    const playAudio = (_duration) => {
        let delay = 0
        setAudioPlaying(true)
        // 如果音频不是从头开始的，继续从当前位置播放
        if (audio.current && audio.current.currentTime > 0) {
            const currentTime = Math.floor(audio.current.currentTime);
            delay = currentTime;
        }
        setTimeout(() => {
            cleatPlayTimer()
            // 遍历 audioMap，判断是否有其他音频在播放
            audioMap.current.forEach((item, key) => {
                // 播放其他音频，除了最后一个
                if (key !== uid && item !== 'ended') {
                    item.play()
                }
            })
            audio.current && audio.current.play()
            playTimer.current = setInterval(() => {
                delay++
                setCurTime(delay)
                if (delay > _duration) {
                    console.log('播放结束')
                    // 清空 audioMap
                    audioMap.current = new Map()
                    cleatPlayTimer()
                    setCurTime(0)
                    audio.current.currentTime = 0
                    setAudioPlaying(false)
                }
            }, 1000);
        }, 100);
    }
    const stopAudio = () => {
        if (audio.current) {
            audio.current.currentTime = 0
            audio.current.pause()
        }
        setCurTime(0)
        clearInterval(playTimer.current)
        playTimer.current = null
        setAudioPlaying(false)
    }

    // 处理接收到的数据
    let _text = ''
    let _textArr = []
    let read_content_uid = ''
    const onMessageReceived = (result) => {
        const data = result.find((item) => item.includes('plugin'));
        if (!data) {
            return;
        }
        const slice = data.split('//');
        console.log('')
        console.log(`命令：${slice[2]}, uid：${slice[3]}`)
        const uid = slice[3]
        if (slice.includes('is_connect_ailab')) {
            sendMessage({ [uid]: `${uid}_success` })
        }
        if (slice.includes('usevoice')) {
            sendMessage({ [uid]: `${uid}_success` })
            const per = slice[4]
            switch (per) {
                case '5003':
                    setParameter(pre => ({ ...pre, voice: '磁性男声', per }))
                    break;
                case '106':
                    setParameter(pre => ({ ...pre, voice: '情感男声', per }))
                    break;
                case '110':
                    setParameter(pre => ({ ...pre, voice: '活泼男童', per }))
                    break;
                case '103':
                    setParameter(pre => ({ ...pre, voice: '甜美女声', per }))
                    break;
                case '5118':
                    setParameter(pre => ({ ...pre, voice: '情感女声', per }))
                    break;
                case '111':
                    setParameter(pre => ({ ...pre, voice: '可爱女童1', per }))
                    break;
                case '4':
                    setParameter(pre => ({ ...pre, voice: '可爱女童2', per }))
                    break;
                default:
                    setParameter(pre => ({ ...pre, voice: slice[4], per }))
                    break;
            }
        }
        if (slice.includes('set_type_to_num')) {
            sendMessage({ [uid]: `${uid}_success` })
            const params = slice[4].split(',');
            setParameter(pre => ({ ...pre, [params[0]]: params[1] }))
        }
        if (slice.includes('read_content_untildone') || slice.includes('read_content')) {
            stopAudio()
            const params = slice[4].split('##');
            const length = params[0];
            if (uid !== read_content_uid) {
                read_content_uid = uid
                _text = ''
                _textArr = []
                setText('')
            }
            _textArr[(params[1] - 1)] = params[2]

            console.log(`共${length}段，第${(params[1])}段：${params[2]}`)
            if (_textArr.filter(f => !!f).length == length) {
                _text = _textArr.join('')
                setText(_text)
                sendMessage({ [uid]: `${uid}_success` })
                setUid(uid)
            }
        }
        if (slice.includes('stop_reading')) {
            stopAudio()
            sendMessage({ [uid]: `${uid}_success` })
        }
    }

    useEffect(() => {
        setupNotifications(onMessageReceived)
        return () => {
            stopNotifications(onMessageReceived)
            stopAudio()
        };
    }, [bluetooth]);
    useEffect(() => {
        if (audioPoint.current) {
            audioPoint.current.style.left = `${(398 / duration) * curTime}px`
            curProgress.current.style.width = `${(curTime / duration) * 100}%`
        }
    }, [curTime, duration])
    return (
        <div className='speechcx2 plug-in'>
            <div className='plug-in-name'>语音合成 2.0</div>
            <div className='plug-in-content'>
                <div className='desc-content'>
                    <div className='title'>语音合成的原理就像让计算机学会「说话」：</div>
                    <div className='desc-content'>
                        首先，系统会把输入的文字拆解成词语和句子，分析它们的含义和语法结构（比如哪里该停顿、哪里要重读）。<br />
                        接着，计算机会根据这些分析结果规划语音的节奏、音调和强弱，就像给文字加上「情感标签」，让合成的语音听起来自然流畅。<br />
                        最后，系统会通过两种主要方式生成声音——要么像拼图一样，从预先录制的大量语音片段中挑选合适的部分拼接起来；要么用数学公式模拟人类声道的震动特性，通过调整音高、音色等参数直接合成语音波形。
                    </div>
                    <div className='desc-content describe'>本扩展可在互联创作平台使用，或连接主控硬件后结合硬件编程平台使用。</div>
                </div>
                <div className='parameter'>
                    <div className='title'>当前参数</div>
                    <div className='parameter-content'>
                        <div className='parameter-item'>
                            <div className='name'>声音：</div>
                            <div className='value'>{parameter.voice}</div>
                        </div>
                        <div className='parameter-item'>
                            <div className='name'>语速：</div>
                            <div className='value'>{parameter.spd}</div>
                        </div>
                        <div className='parameter-item'>
                            <div className='name'>音调：</div>
                            <div className='value'>{parameter.pit}</div>
                        </div>
                        <div className='parameter-item'>
                            <div className='name'>音量：</div>
                            <div className='value'>{parameter.vol}</div>
                        </div>
                    </div>
                    {
                        hasAudio && <div className='desc border'>
                            <div className='scroll'>
                                {text}
                            </div>
                        </div>
                    }

                </div>
                <div className='voice'>
                    <div className='title'>最近一次合成的语音</div>
                    <div className='border'>
                        {
                            hasAudio ?
                                (
                                    loading ?
                                            <div className='synthesising'>
                                                <div className='loading'><Spin /></div>
                                                <div>合成中…</div>
                                            </div> :
                                            <div className='audio'>
                                                <div className='play-btn'>
                                                    {
                                                        audioPlaying ?
                                                            <img src="/image/speaker/pause-hover.png" className='play' alt="" /> :
                                                            <img src="/image/speaker/play-hover.png" className='pause' alt="" onClick={() => playAudio(duration)} />
                                                    }
                                                </div>
                                                <div className='audio-progress'>
                                                    <div className='point' ref={audioPoint}></div>
                                                    <div className='line'>
                                                        <div className='cur-progress' ref={curProgress}></div>
                                                    </div>
                                                </div>
                                                <div className='duration'>{curTime} / {duration}</div>
                                            </div>
                                ) :
                                <div className='not-synthesis'>暂未进行过合成</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Speechcx2;